import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
  },
  chip: {
    marginBottom: theme.spacing(0),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    marginBlock: theme.spacing(2.5, 3),
  },
  paper: {
    height: '100%',
    padding: theme.spacing(4),
  },
  papeTitleWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  paperContent: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  shippingSubtitle: {
    margin: theme.spacing(2.5, 0),
  },
  shippingContent: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
  shippingInput: {
    flex: 1,
  },
  shippingButton: {
    marginLeft: theme.spacing(1),
    height: theme.spacing(5),
  },
  paperShipmentLocator: {
    display: 'flex',
    flexDirection: 'column',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  filters: {
    '& .MuiButton-root': {
      padding: theme.spacing(0.5, 1.5),
    },
  },
  resultsLoaderWrapper: {
    height: '100%',
    minHeight: 401.3,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export default useStyles
